import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Constants } from '@shared/utils/constants';
import { Link, Text } from '@fluentui/react';
import { useSpzaInstrumentService } from '@shared/hooks/useSpzaInstrumentService';
import { logger } from '@src/logger';
import { useBoolean } from '@fluentui/react-hooks';
import { AzureRedirectModal } from '@appsource/components/AzureRedirectModal/AzureRedirectModal';
export const AzureSubscriptionPurchase = ({ hidden, offerId }, context)=>{
    const [linkClicked, { toggle: toggleLinkClicked }] = useBoolean(false);
    const checkoutId = useSelector(({ checkout })=>checkout.checkoutId);
    const [instrument] = useSpzaInstrumentService();
    const createLink = `${Constants.AzurePortal.CreateOfferById}${offerId}`;
    const linkNodeName = 'A';
    const handleClick = (e)=>{
        const url = e.target.href;
        const { nodeName } = e.target;
        if (nodeName === linkNodeName && url === createLink) {
            const payload = {
                page: location.pathname,
                action: Constants.Telemetry.Action.Checkout,
                actionModifier: Constants.Telemetry.ActionModifier.AzureRedirect,
                details: JSON.stringify({
                    createLink,
                    checkoutId
                })
            };
            instrument.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
            logger.info(payload.details, payload);
            toggleLinkClicked();
        }
    };
    return !hidden && /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Text, {
                onClick: handleClick,
                variant: "smallPlus",
                children: [
                    context.loc('Checkout_CreateInAzurePortal'),
                    /*#__PURE__*/ _jsx(Link, {
                        target: "_blank",
                        href: createLink,
                        children: context.loc('Checkout_CreateInAzurePortal_AzurePortal')
                    }),
                    context.loc('Checkout_CreateInAzurePortal_LearnMore'),
                    /*#__PURE__*/ _jsx(Link, {
                        target: "_blank",
                        href: Constants.AzureSubscriptionLink,
                        children: context.loc('App_LearnMore', 'Learn more')
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(AzureRedirectModal, {
                linkClicked: linkClicked,
                onDismiss: ()=>toggleLinkClicked()
            })
        ]
    });
};
AzureSubscriptionPurchase.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func
};
